/**
 * E-Mail-Template-Typen der Plattform.
 *
 * Die Werte entsprechen 1:1 dem Enum `TemplateType` in netz-services und werden so
 * gespeichert und übertragen. Das Backend-Enum wird numerisch über seinen Ordinalwert
 * persistiert — dort darf weder umbenannt noch umsortiert werden, sonst zeigen bestehende
 * Datensätze auf andere Templates. Anzeigename und Reihenfolge entstehen deshalb
 * ausschließlich hier im Client.
 *
 * Namensschema: `<Modul> - <Dokumentname>` — ausgeschrieben, deutsch, `" - "` als einziges
 * Trennelement. Nicht mehr verwendete Templates tragen `(Obsolet)` bzw. `(Nicht genutzt)`
 * vor dem Dokumentnamen.
 */
export enum MailTemplateTypeEnum {
  // Sonstiges
  DEFAULT = 'DEFAULT',
  NEW_MESSAGE_NOTIFICATION = 'NEW_MESSAGE_NOTIFICATION',
  MAIL_FOOTER = 'MAIL_FOOTER',
  CUSTOMER_CSS = 'CUSTOMER_CSS',
  PRINT_ALL_VALUES = 'PRINT_ALL_VALUES',
  BUILDING_REPORT = 'BUILDING_REPORT',
  BUILDING_DOSSIER = 'BUILDING_DOSSIER',

  // Hausanschluss
  OFFER_REQUEST_CONFIRMATION = 'OFFER_REQUEST_CONFIRMATION',
  ORDER_CONFIRMATION = 'ORDER_CONFIRMATION',
  ORDER_CONFIRMATION_REQUEST = 'ORDER_CONFIRMATION_REQUEST',
  ORDER_CONFIRMATION_LETTER = 'ORDER_CONFIRMATION_LETTER',
  ORDER_REQUEST_LETTER = 'ORDER_REQUEST_LETTER',
  BREAKUP_NOTICE = 'BREAKUP_NOTICE',
  BREAKUP_NOTICE_PAGE_2 = 'BREAKUP_NOTICE_PAGE_2',
  CANCELLATION_LETTER = 'CANCELLATION_LETTER',
  BUYING_CONTRACT = 'BUYING_CONTRACT',
  ORDER_CONFIRMATION_DELETE = 'ORDER_CONFIRMATION_DELETE',
  OR_REQUEST_APPROVAL = 'OR_REQUEST_APPROVAL',
  ORDER_REQUEST_APPROVED = 'ORDER_REQUEST_APPROVED',
  ORDER_CONFIRMATION_INTRO = 'ORDER_CONFIRMATION_INTRO',
  OFFER_REQUEST_INTRO = 'OFFER_REQUEST_INTRO',
  ORDER_REQUEST_FELIX_PROJECT = 'ORDER_REQUEST_FELIX_PROJECT',
  CONSTRUCTION_FILE = 'CONSTRUCTION_FILE',
  ORDER_REQUEST_CANCELED = 'ORDER_REQUEST_CANCELED',
  ORDER_REQUEST_INTERN_INFO_CANCELED = 'ORDER_REQUEST_INTERN_INFO_CANCELED',
  ORDER_REQUEST_CREATED_INSTALLER_INFO = 'ORDER_REQUEST_CREATED_INSTALLER_INFO',
  ORDER_REVOCATION = 'ORDER_REVOCATION',
  ORDER_REVOCATION_CONFIRMATION = 'ORDER_REVOCATION_CONFIRMATION',
  DATA_SHEET_HA_GASWATER = 'DATA_SHEET_HA_GASWATER',
  COMMISSIONING_CHECK = 'COMMISSIONING_CHECK',
  EXPLOSIVE_ORDNANCE_DISPOSAL_INFO = 'EXPLOSIVE_ORDNANCE_DISPOSAL_INFO',
  EXPLOSIVE_ORDNANCE_DISPOSAL_ACCOMPANIMENT = 'EXPLOSIVE_ORDNANCE_DISPOSAL_ACCOMPANIMENT',
  ORDER_CONFIRMATION_LETTER_TEMPWATER = 'ORDER_CONFIRMATION_LETTER_TEMPWATER',
  ORDER_CONFIRMATION_LETTER_TEMPPOWER = 'ORDER_CONFIRMATION_LETTER_TEMPPOWER',
  ORDER_CONFIRMATION_LETTER_GAS = 'ORDER_CONFIRMATION_LETTER_GAS',
  ORDER_CONFIRMATION_LETTER_WATER = 'ORDER_CONFIRMATION_LETTER_WATER',
  ORDER_CONFIRMATION_LETTER_POWER = 'ORDER_CONFIRMATION_LETTER_POWER',
  ORDER_CONFIRMATION_WATER_METER_Q34 = 'ORDER_CONFIRMATION_WATER_METER_Q34',
  ORDER_CONFIRMATION_WATER_METER_Q310 = 'ORDER_CONFIRMATION_WATER_METER_Q310',
  ORDER_CONFIRMATION_GAS_HA_KASTEN = 'ORDER_CONFIRMATION_GAS_HA_KASTEN',
  ORDER_CONFIRMATION_METER_COLUMN = 'ORDER_CONFIRMATION_METER_COLUMN',
  NAV_GRID_CONNECTION_CONTRACT = 'NAV_GRID_CONNECTION_CONTRACT',
  NAV_MS_GRID_CONNECTION_CONTRACT = 'NAV_MS_GRID_CONNECTION_CONTRACT',
  NDAV_GAS_GRID_CONNECTION_CONTRACT = 'NDAV_GAS_GRID_CONNECTION_CONTRACT',

  // Benutzerverwaltung
  MAIL_CONFIRMATION_REQUEST = 'MAIL_CONFIRMATION_REQUEST',
  PASSWORD_CHANGE_REQUEST = 'PASSWORD_CHANGE_REQUEST',

  // Installateur
  TM_WELLCOME_ADMIN_INSTALLATEUR = 'TM_WELLCOME_ADMIN_INSTALLATEUR',
  TM_PASS_REJECTED = 'TM_PASS_REJECTED',
  TM_INSTALLER_PASS = 'TM_INSTALLER_PASS',
  TM_PASS_VALID = 'TM_PASS_VALID',
  TM_PASS_RENEWED = 'TM_PASS_RENEWED',
  TM_PASS_FEEDBACK_NEEDED = 'TM_PASS_FEEDBACK_NEEDED',
  TM_PASS_REQUEST_RENOVATION = 'TM_PASS_REQUEST_RENOVATION',
  TM_PASS_EXPIRATION_REMINDER = 'TM_PASS_EXPIRATION_REMINDER',

  // Inbetriebnahme
  COM_BBS_APPROVAL = 'COM_BBS_APPROVAL',
  COM_VALID = 'COM_VALID',
  COM_SUPPLY_DATE_APPOINTMENT = 'COM_SUPPLY_DATE_APPOINTMENT',
  COM_CHANGE_SUPPLY_APPOINTMENT = 'COM_CHANGE_SUPPLY_APPOINTMENT',
  COM_REQUESTED = 'COM_REQUESTED',
  COM_INFO_SHEET = 'COM_INFO_SHEET',
  COM_CLOSED = 'COM_CLOSED',
  COM_FEEDBACK_NEEDED = 'COM_FEEDBACK_NEEDED',
  COM_CORRECT = 'COM_CORRECT',
  TM_CM_CHIMNEYSWEEP_INFO = 'TM_CM_CHIMNEYSWEEP_INFO',
  COM_CHIMNEY_SWEEP_INFO = 'COM_CHIMNEY_SWEEP_INFO',
  COM_CHIMNEYSWEEP_REQUESTED = 'COM_CHIMNEYSWEEP_REQUESTED',
  COM_CHIMNEYSWEEP_CONFIRMED = 'COM_CHIMNEYSWEEP_CONFIRMED',
  COM_CHIMNEYSWEEP_REJECTED = 'COM_CHIMNEYSWEEP_REJECTED',
  COM_CHIMNEYSWEEP_INFORMATION = 'COM_CHIMNEYSWEEP_INFORMATION',
  METER_CHANGE_FORM = 'METER_CHANGE_FORM',
  COM_INSTALLATION_COMPLETED = 'COM_INSTALLATION_COMPLETED',
  COM_DEFECT_REPORTED = 'COM_DEFECT_REPORTED',
  COM_REQUESTED_IMSYS = 'COM_REQUESTED_IMSYS',
  COM_REQUESTED_GAS_CANCELLATION = 'COM_REQUESTED_GAS_CANCELLATION',
  COM_REQUESTED_INSPECTION = 'COM_REQUESTED_INSPECTION',
  COM_SEND_OFFER = 'COM_SEND_OFFER',
  COM_TECHNICAL_REVIEW = 'COM_TECHNICAL_REVIEW',

  // Netzanmeldung
  TM_GRID_REGISTRATION_VALID = 'TM_GRID_REGISTRATION_VALID',
  TM_GRID_REGISTRATION_DECLINED = 'TM_GRID_REGISTRATION_DECLINED',
  TM_GRID_REGISTRATION_REQUEST_VALIDATION = 'TM_GRID_REGISTRATION_REQUEST_VALIDATION',
  TM_GR_REQUESTED_CUSTOMER_INFO = 'TM_GR_REQUESTED_CUSTOMER_INFO',
  TM_GRID_REGISTRATION_FEEDBACK_NEEDED = 'TM_GRID_REGISTRATION_FEEDBACK_NEEDED',
  TM_GRID_REGISTRATION_INFO_SHEET = 'TM_GRID_REGISTRATION_INFO_SHEET',
  GR_PLACE_IN_SERVICE_REQUESTED = 'GR_PLACE_IN_SERVICE_REQUESTED',
  GR_PLACE_IN_SERVICE_CONFIRMED = 'GR_PLACE_IN_SERVICE_CONFIRMED',
  TM_GRID_REGISTRATION_REQUEST_ORDER = 'TM_GRID_REGISTRATION_REQUEST_ORDER',
  TM_GRID_REGISTRATION_ORDER_CONFIRMATION = 'TM_GRID_REGISTRATION_ORDER_CONFIRMATION',
  TM_GRID_REGISTRATION_FEED_IN_READY = 'TM_GRID_REGISTRATION_FEED_IN_READY',
  TM_GRID_REGISTRATION_PENDING_ASSIGN_TECHNICIAN = 'TM_GRID_REGISTRATION_PENDING_ASSIGN_TECHNICIAN',
  TM_GRID_REGISTRATION_ASSIGNED_TO_TECHNICIAN = 'TM_GRID_REGISTRATION_ASSIGNED_TO_TECHNICIAN',
  TM_GRID_REGISTRATION_SHARE_TO_TECHNICIAN_REQUEST = 'TM_GRID_REGISTRATION_SHARE_TO_TECHNICIAN_REQUEST',
  TM_GRID_REGISTRATION_SHARE_TO_TECHNICIAN_ACCEPT = 'TM_GRID_REGISTRATION_SHARE_TO_TECHNICIAN_ACCEPT',
  TM_GRID_REGISTRATION_CORRECT = 'TM_GRID_REGISTRATION_CORRECT',
  TM_GRID_REGISTRATION_REMINDER = 'TM_GRID_REGISTRATION_REMINDER',
  TM_GRID_REGISTRATION_SEND_TO_REVIEW = 'TM_GRID_REGISTRATION_SEND_TO_REVIEW',
  TM_GRID_REGISTRATION_SEND_TO_REVIEW_INTERNAL = 'TM_GRID_REGISTRATION_SEND_TO_REVIEW_INTERNAL',
  PLUGIN_GRID_REGISTRATION_RECEIVED = 'PLUGIN_GRID_REGISTRATION_RECEIVED',
  PLUGIN_GRID_REGISTRATION_DECLINED = 'PLUGIN_GRID_REGISTRATION_DECLINED',
  PLUGIN_GRID_REGISTRATION_APPROVED_METER = 'PLUGIN_GRID_REGISTRATION_APPROVED_METER',
  PLUGIN_GRID_REGISTRATION_APPROVED_NO_METER = 'PLUGIN_GRID_REGISTRATION_APPROVED_NO_METER',
  PLUGIN_GRID_REGISTRATION_FEEDBACK_NEEDED = 'PLUGIN_GRID_REGISTRATION_FEEDBACK_NEEDED',
  GR_NOTIFY_MALO_MELO = 'GR_NOTIFY_MALO_MELO',
  GR_NOTIFY_TR_SR = 'GR_NOTIFY_TR_SR',
  GR_NEW_FEEDER_DIREKT_MARKET = 'GR_NEW_FEEDER_DIREKT_MARKET',
  GR_IB_CONFIRMED_FEEDER_DIRECT_MARKET = 'GR_IB_CONFIRMED_FEEDER_DIRECT_MARKET',
  GR_FEED_IN_MGMT_ORDERED = 'GR_FEED_IN_MGMT_ORDERED',
  GR_FEED_IN_MGMT_ORDERED_PARAMETRIZE = 'GR_FEED_IN_MGMT_ORDERED_PARAMETRIZE',

  // Einspeisevertrag
  FEEDER_CONTRACT = 'FEEDER_CONTRACT',
  PV_REGISTRATION_FORM = 'PV_REGISTRATION_FORM',
  FEEDER_CONTRACT_CONFIRMED = 'FEEDER_CONTRACT_CONFIRMED',
  FEEDER_CONTRACT_CONFIRMATION_REQUEST = 'FEEDER_CONTRACT_CONFIRMATION_REQUEST',
  FEEDER_CONTRACT_ACCEPTED = 'FEEDER_CONTRACT_ACCEPTED',
  FEEDER_CONTRACT_FEEDBACK_NEEDED = 'FEEDER_CONTRACT_FEEDBACK_NEEDED',
  FEEDER_CONTRACT_CONFIRMATION_REQUEST_INFO_SHEET = 'FEEDER_CONTRACT_CONFIRMATION_REQUEST_INFO_SHEET',
  FC_CONFIRMATION_WITHOUT_CONTRACT = 'FC_CONFIRMATION_WITHOUT_CONTRACT',
  FC_CONFIRMATION_WITHOUT_CONTRACT_INFO_SHEET = 'FC_CONFIRMATION_WITHOUT_CONTRACT_INFO_SHEET',
  FEEDER_WITHOUT_CONTRACT_ACCEPTED = 'FEEDER_WITHOUT_CONTRACT_ACCEPTED',
  FEEDER_CONTRACT_CONFIRMATION_REQUEST_REMINDER = 'FEEDER_CONTRACT_CONFIRMATION_REQUEST_REMINDER',

  // Anschlussänderung
  CCR_REQUESTED = 'CCR_REQUESTED',
  CCR_INFO_SHEET = 'CCR_INFO_SHEET',
  CCR_FEEDBACK_NEEDED = 'CCR_FEEDBACK_NEEDED',
  CCR_OFFER_CONFIRMATION_REQUEST = 'CCR_OFFER_CONFIRMATION_REQUEST',
  CCR_CONFIRMATION_MAIL = 'CCR_CONFIRMATION_MAIL'
}

export type MailTemplateTypeValue = `${MailTemplateTypeEnum}`;

/**
 * Anzeigename je Template-Typ. Ein hier nicht gelistetes Template fällt in
 * {@link MetaService} auf den Titel aus dem Backend zurück — neue Backend-Templates
 * brechen also nichts, erscheinen aber mit ihrem alten Titel, bis sie hier eintragen sind.
 */
export const MailTemplateTypeConst: Record<
  MailTemplateTypeValue,
  { value: MailTemplateTypeValue; displayName: string }
> = {
  // Sonstiges
  [MailTemplateTypeEnum.DEFAULT]: {
    value: MailTemplateTypeEnum.DEFAULT,
    displayName: 'Sonstiges - Leere Standard-Mail'
  },
  [MailTemplateTypeEnum.NEW_MESSAGE_NOTIFICATION]: {
    value: MailTemplateTypeEnum.NEW_MESSAGE_NOTIFICATION,
    displayName: 'Sonstiges - Neue Benachrichtigung'
  },
  [MailTemplateTypeEnum.MAIL_FOOTER]: {
    value: MailTemplateTypeEnum.MAIL_FOOTER,
    displayName: 'Sonstiges - Globale E-Mail-Signatur'
  },
  [MailTemplateTypeEnum.CUSTOMER_CSS]: {
    value: MailTemplateTypeEnum.CUSTOMER_CSS,
    displayName: 'Sonstiges - Globales Mail-CSS'
  },
  [MailTemplateTypeEnum.PRINT_ALL_VALUES]: {
    value: MailTemplateTypeEnum.PRINT_ALL_VALUES,
    displayName: 'Sonstiges - Debug-Template alle Felder'
  },
  [MailTemplateTypeEnum.BUILDING_REPORT]: {
    value: MailTemplateTypeEnum.BUILDING_REPORT,
    displayName: 'Sonstiges - (Nicht genutzt) Bauakte'
  },
  [MailTemplateTypeEnum.BUILDING_DOSSIER]: {
    value: MailTemplateTypeEnum.BUILDING_DOSSIER,
    displayName: 'Sonstiges - (Obsolet) Bauakte'
  },

  // Hausanschluss
  [MailTemplateTypeEnum.OFFER_REQUEST_CONFIRMATION]: {
    value: MailTemplateTypeEnum.OFFER_REQUEST_CONFIRMATION,
    displayName: 'Hausanschluss - Bestätigung Angebotsanfrage'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION,
    displayName: 'Hausanschluss - Bestellbestätigung'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_REQUEST]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_REQUEST,
    displayName: 'Hausanschluss - Online-Angebot mit Link'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER,
    displayName: 'Hausanschluss - Druck Bestellbestätigung'
  },
  [MailTemplateTypeEnum.ORDER_REQUEST_LETTER]: {
    value: MailTemplateTypeEnum.ORDER_REQUEST_LETTER,
    displayName: 'Hausanschluss - Druck Angebot'
  },
  [MailTemplateTypeEnum.BREAKUP_NOTICE]: {
    value: MailTemplateTypeEnum.BREAKUP_NOTICE,
    displayName: 'Hausanschluss - Aufbruchanzeige'
  },
  [MailTemplateTypeEnum.BREAKUP_NOTICE_PAGE_2]: {
    value: MailTemplateTypeEnum.BREAKUP_NOTICE_PAGE_2,
    displayName: 'Hausanschluss - Aufbruchanzeige Seite 2'
  },
  [MailTemplateTypeEnum.CANCELLATION_LETTER]: {
    value: MailTemplateTypeEnum.CANCELLATION_LETTER,
    displayName: 'Hausanschluss - Druck Absage'
  },
  [MailTemplateTypeEnum.BUYING_CONTRACT]: {
    value: MailTemplateTypeEnum.BUYING_CONTRACT,
    displayName: 'Hausanschluss - Druck Kaufvertrag'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_DELETE]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_DELETE,
    displayName: 'Hausanschluss - Anfrage gelöscht'
  },
  [MailTemplateTypeEnum.OR_REQUEST_APPROVAL]: {
    value: MailTemplateTypeEnum.OR_REQUEST_APPROVAL,
    displayName: 'Hausanschluss - Anfrage zur Freigabe intern'
  },
  [MailTemplateTypeEnum.ORDER_REQUEST_APPROVED]: {
    value: MailTemplateTypeEnum.ORDER_REQUEST_APPROVED,
    displayName: 'Hausanschluss - Freigabe erteilt intern'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_INTRO]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_INTRO,
    displayName: 'Hausanschluss - Einleitung Bestellbestätigung'
  },
  [MailTemplateTypeEnum.OFFER_REQUEST_INTRO]: {
    value: MailTemplateTypeEnum.OFFER_REQUEST_INTRO,
    displayName: 'Hausanschluss - Einleitung Angebotsanfrage'
  },
  [MailTemplateTypeEnum.ORDER_REQUEST_FELIX_PROJECT]: {
    value: MailTemplateTypeEnum.ORDER_REQUEST_FELIX_PROJECT,
    displayName: 'Hausanschluss - Felix-Integration'
  },
  [MailTemplateTypeEnum.CONSTRUCTION_FILE]: {
    value: MailTemplateTypeEnum.CONSTRUCTION_FILE,
    displayName: 'Hausanschluss - Bauakte'
  },
  [MailTemplateTypeEnum.ORDER_REQUEST_CANCELED]: {
    value: MailTemplateTypeEnum.ORDER_REQUEST_CANCELED,
    displayName: 'Hausanschluss - Bestätigung Widerruf'
  },
  [MailTemplateTypeEnum.ORDER_REQUEST_INTERN_INFO_CANCELED]: {
    value: MailTemplateTypeEnum.ORDER_REQUEST_INTERN_INFO_CANCELED,
    displayName: 'Hausanschluss - Bestätigung Widerruf intern'
  },
  [MailTemplateTypeEnum.ORDER_REQUEST_CREATED_INSTALLER_INFO]: {
    value: MailTemplateTypeEnum.ORDER_REQUEST_CREATED_INSTALLER_INFO,
    displayName: 'Hausanschluss - Neue Anfrage Installateursinfo'
  },
  [MailTemplateTypeEnum.ORDER_REVOCATION]: {
    value: MailTemplateTypeEnum.ORDER_REVOCATION,
    displayName: 'Hausanschluss - Widerrufsformular'
  },
  [MailTemplateTypeEnum.ORDER_REVOCATION_CONFIRMATION]: {
    value: MailTemplateTypeEnum.ORDER_REVOCATION_CONFIRMATION,
    displayName: 'Hausanschluss - Bestätigung Widerruf Formular'
  },
  [MailTemplateTypeEnum.DATA_SHEET_HA_GASWATER]: {
    value: MailTemplateTypeEnum.DATA_SHEET_HA_GASWATER,
    displayName: 'Hausanschluss - Datenerfassungsblatt Gas und Wasser'
  },
  [MailTemplateTypeEnum.COMMISSIONING_CHECK]: {
    value: MailTemplateTypeEnum.COMMISSIONING_CHECK,
    displayName: 'Hausanschluss - Überprüfungsprotokoll Inbetriebnahme'
  },
  [MailTemplateTypeEnum.EXPLOSIVE_ORDNANCE_DISPOSAL_INFO]: {
    value: MailTemplateTypeEnum.EXPLOSIVE_ORDNANCE_DISPOSAL_INFO,
    displayName: 'Hausanschluss - Anfrage Kampfmittelbeseitigung'
  },
  [MailTemplateTypeEnum.EXPLOSIVE_ORDNANCE_DISPOSAL_ACCOMPANIMENT]: {
    value: MailTemplateTypeEnum.EXPLOSIVE_ORDNANCE_DISPOSAL_ACCOMPANIMENT,
    displayName: 'Hausanschluss - Anfrage Kampfmittelbegleitung'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_TEMPWATER]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_TEMPWATER,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Bauwasser'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_TEMPPOWER]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_TEMPPOWER,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Baustrom'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_GAS]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_GAS,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Gas'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_WATER]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_WATER,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Wasser'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_POWER]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_LETTER_POWER,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Strom'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_WATER_METER_Q34]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_WATER_METER_Q34,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Wasserzähler Q3-4'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_WATER_METER_Q310]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_WATER_METER_Q310,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Wasserzähler Q3-10'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_GAS_HA_KASTEN]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_GAS_HA_KASTEN,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Gas-Hausanschlusskasten'
  },
  [MailTemplateTypeEnum.ORDER_CONFIRMATION_METER_COLUMN]: {
    value: MailTemplateTypeEnum.ORDER_CONFIRMATION_METER_COLUMN,
    displayName: 'Hausanschluss - Druck Bestellbestätigung Zähleranschlusssäule'
  },
  [MailTemplateTypeEnum.NAV_GRID_CONNECTION_CONTRACT]: {
    value: MailTemplateTypeEnum.NAV_GRID_CONNECTION_CONTRACT,
    displayName: 'Hausanschluss - NAV-Netzanschlussvertrag'
  },
  [MailTemplateTypeEnum.NAV_MS_GRID_CONNECTION_CONTRACT]: {
    value: MailTemplateTypeEnum.NAV_MS_GRID_CONNECTION_CONTRACT,
    displayName: 'Hausanschluss - NAV-Netzanschlussvertrag Mittelspannung'
  },
  [MailTemplateTypeEnum.NDAV_GAS_GRID_CONNECTION_CONTRACT]: {
    value: MailTemplateTypeEnum.NDAV_GAS_GRID_CONNECTION_CONTRACT,
    displayName: 'Hausanschluss - NDAV-Niederdruckanschlussvertrag Gas'
  },

  // Benutzerverwaltung
  [MailTemplateTypeEnum.MAIL_CONFIRMATION_REQUEST]: {
    value: MailTemplateTypeEnum.MAIL_CONFIRMATION_REQUEST,
    displayName: 'Benutzerverwaltung - Bestätigungsmail'
  },
  [MailTemplateTypeEnum.PASSWORD_CHANGE_REQUEST]: {
    value: MailTemplateTypeEnum.PASSWORD_CHANGE_REQUEST,
    displayName: 'Benutzerverwaltung - Passwort ändern'
  },

  // Installateur
  [MailTemplateTypeEnum.TM_WELLCOME_ADMIN_INSTALLATEUR]: {
    value: MailTemplateTypeEnum.TM_WELLCOME_ADMIN_INSTALLATEUR,
    displayName: 'Installateur - Willkommensnachricht'
  },
  [MailTemplateTypeEnum.TM_PASS_REJECTED]: {
    value: MailTemplateTypeEnum.TM_PASS_REJECTED,
    displayName: 'Installateur - Ausweis abgelehnt'
  },
  [MailTemplateTypeEnum.TM_INSTALLER_PASS]: {
    value: MailTemplateTypeEnum.TM_INSTALLER_PASS,
    displayName: 'Installateur - Ausweis'
  },
  [MailTemplateTypeEnum.TM_PASS_VALID]: {
    value: MailTemplateTypeEnum.TM_PASS_VALID,
    displayName: 'Installateur - Ausweis freigegeben'
  },
  [MailTemplateTypeEnum.TM_PASS_RENEWED]: {
    value: MailTemplateTypeEnum.TM_PASS_RENEWED,
    displayName: 'Installateur - Ausweis verlängert'
  },
  [MailTemplateTypeEnum.TM_PASS_FEEDBACK_NEEDED]: {
    value: MailTemplateTypeEnum.TM_PASS_FEEDBACK_NEEDED,
    displayName: 'Installateur - Rückfrage zu Ausweis'
  },
  [MailTemplateTypeEnum.TM_PASS_REQUEST_RENOVATION]: {
    value: MailTemplateTypeEnum.TM_PASS_REQUEST_RENOVATION,
    displayName: 'Installateur - Ausweis Beantragung oder Verlängerung angefragt'
  },
  [MailTemplateTypeEnum.TM_PASS_EXPIRATION_REMINDER]: {
    value: MailTemplateTypeEnum.TM_PASS_EXPIRATION_REMINDER,
    displayName: 'Installateur - Erinnerung 90 Tage vor Ablauf'
  },

  // Inbetriebnahme
  [MailTemplateTypeEnum.COM_BBS_APPROVAL]: {
    value: MailTemplateTypeEnum.COM_BBS_APPROVAL,
    displayName: 'Inbetriebnahme - (Obsolet) Freigabe Bezirksschornsteinfeger'
  },
  [MailTemplateTypeEnum.COM_VALID]: {
    value: MailTemplateTypeEnum.COM_VALID,
    displayName: 'Inbetriebnahme - Freigabe'
  },
  [MailTemplateTypeEnum.COM_SUPPLY_DATE_APPOINTMENT]: {
    value: MailTemplateTypeEnum.COM_SUPPLY_DATE_APPOINTMENT,
    displayName: 'Inbetriebnahme - (Obsolet) Durchführungstermin'
  },
  [MailTemplateTypeEnum.COM_CHANGE_SUPPLY_APPOINTMENT]: {
    value: MailTemplateTypeEnum.COM_CHANGE_SUPPLY_APPOINTMENT,
    displayName: 'Inbetriebnahme - Bestätigung neuer Durchführungstermin'
  },
  [MailTemplateTypeEnum.COM_REQUESTED]: {
    value: MailTemplateTypeEnum.COM_REQUESTED,
    displayName: 'Inbetriebnahme - Anfragebestätigung'
  },
  [MailTemplateTypeEnum.COM_INFO_SHEET]: {
    value: MailTemplateTypeEnum.COM_INFO_SHEET,
    displayName: 'Inbetriebnahme - Datenblatt'
  },
  [MailTemplateTypeEnum.COM_CLOSED]: {
    value: MailTemplateTypeEnum.COM_CLOSED,
    displayName: 'Inbetriebnahme - Abschlussmeldung'
  },
  [MailTemplateTypeEnum.COM_FEEDBACK_NEEDED]: {
    value: MailTemplateTypeEnum.COM_FEEDBACK_NEEDED,
    displayName: 'Inbetriebnahme - Rückfrage'
  },
  [MailTemplateTypeEnum.COM_CORRECT]: {
    value: MailTemplateTypeEnum.COM_CORRECT,
    displayName: 'Inbetriebnahme - Zur Korrektur zurückgezogen'
  },
  [MailTemplateTypeEnum.TM_CM_CHIMNEYSWEEP_INFO]: {
    value: MailTemplateTypeEnum.TM_CM_CHIMNEYSWEEP_INFO,
    displayName: 'Inbetriebnahme - (Obsolet) Schornsteinfeger Information'
  },
  [MailTemplateTypeEnum.COM_CHIMNEY_SWEEP_INFO]: {
    value: MailTemplateTypeEnum.COM_CHIMNEY_SWEEP_INFO,
    displayName: 'Inbetriebnahme - (Obsolet) Schornsteinfeger Info'
  },
  [MailTemplateTypeEnum.COM_CHIMNEYSWEEP_REQUESTED]: {
    value: MailTemplateTypeEnum.COM_CHIMNEYSWEEP_REQUESTED,
    displayName: 'Inbetriebnahme - Anfrage Schornsteinfeger Bestätigung'
  },
  [MailTemplateTypeEnum.COM_CHIMNEYSWEEP_CONFIRMED]: {
    value: MailTemplateTypeEnum.COM_CHIMNEYSWEEP_CONFIRMED,
    displayName: 'Inbetriebnahme - Schornsteinfeger Bestätigung'
  },
  [MailTemplateTypeEnum.COM_CHIMNEYSWEEP_REJECTED]: {
    value: MailTemplateTypeEnum.COM_CHIMNEYSWEEP_REJECTED,
    displayName: 'Inbetriebnahme - Schornsteinfeger Absage oder Rückfrage'
  },
  [MailTemplateTypeEnum.COM_CHIMNEYSWEEP_INFORMATION]: {
    value: MailTemplateTypeEnum.COM_CHIMNEYSWEEP_INFORMATION,
    displayName: 'Inbetriebnahme - Schornsteinfeger Information'
  },
  [MailTemplateTypeEnum.METER_CHANGE_FORM]: {
    value: MailTemplateTypeEnum.METER_CHANGE_FORM,
    displayName: 'Inbetriebnahme - Zählerwechsel- und Fertigmeldung'
  },
  [MailTemplateTypeEnum.COM_INSTALLATION_COMPLETED]: {
    value: MailTemplateTypeEnum.COM_INSTALLATION_COMPLETED,
    displayName: 'Inbetriebnahme - Fertigmeldung Installateur'
  },
  [MailTemplateTypeEnum.COM_DEFECT_REPORTED]: {
    value: MailTemplateTypeEnum.COM_DEFECT_REPORTED,
    displayName: 'Inbetriebnahme - Mängelmeldung'
  },
  [MailTemplateTypeEnum.COM_REQUESTED_IMSYS]: {
    value: MailTemplateTypeEnum.COM_REQUESTED_IMSYS,
    displayName: 'Inbetriebnahme - Anfragebestätigung iMSys'
  },
  [MailTemplateTypeEnum.COM_REQUESTED_GAS_CANCELLATION]: {
    value: MailTemplateTypeEnum.COM_REQUESTED_GAS_CANCELLATION,
    displayName: 'Inbetriebnahme - Anfragebestätigung Gasstilllegung'
  },
  [MailTemplateTypeEnum.COM_REQUESTED_INSPECTION]: {
    value: MailTemplateTypeEnum.COM_REQUESTED_INSPECTION,
    displayName: 'Inbetriebnahme - Anfragebestätigung Befundprüfung'
  },
  [MailTemplateTypeEnum.COM_SEND_OFFER]: {
    value: MailTemplateTypeEnum.COM_SEND_OFFER,
    displayName: 'Inbetriebnahme - Kostenpflichtig Angebot wird vorbereitet'
  },
  [MailTemplateTypeEnum.COM_TECHNICAL_REVIEW]: {
    value: MailTemplateTypeEnum.COM_TECHNICAL_REVIEW,
    displayName: 'Inbetriebnahme - Technische Prüfung erfolgt'
  },

  // Netzanmeldung
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_VALID]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_VALID,
    displayName: 'Netzanmeldung - Freigabe und Netzzusage'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_DECLINED]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_DECLINED,
    displayName: 'Netzanmeldung - Ablehnung'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_REQUEST_VALIDATION]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_REQUEST_VALIDATION,
    displayName: 'Netzanmeldung - Anfragebestätigung'
  },
  [MailTemplateTypeEnum.TM_GR_REQUESTED_CUSTOMER_INFO]: {
    value: MailTemplateTypeEnum.TM_GR_REQUESTED_CUSTOMER_INFO,
    displayName: 'Netzanmeldung - (Obsolet) Kundeninfo'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_FEEDBACK_NEEDED]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_FEEDBACK_NEEDED,
    displayName: 'Netzanmeldung - (Obsolet) Kundeninfo Rückfrage'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_INFO_SHEET]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_INFO_SHEET,
    displayName: 'Netzanmeldung - Datenblatt'
  },
  [MailTemplateTypeEnum.GR_PLACE_IN_SERVICE_REQUESTED]: {
    value: MailTemplateTypeEnum.GR_PLACE_IN_SERVICE_REQUESTED,
    displayName: 'Netzanmeldung - Inbetriebnahmeprotokoll Anfrage zur Bestätigung der Daten'
  },
  [MailTemplateTypeEnum.GR_PLACE_IN_SERVICE_CONFIRMED]: {
    value: MailTemplateTypeEnum.GR_PLACE_IN_SERVICE_CONFIRMED,
    displayName: 'Netzanmeldung - Inbetriebnahmeprotokoll bestätigt durch Kunde'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_REQUEST_ORDER]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_REQUEST_ORDER,
    displayName: 'Netzanmeldung - Anfrage Bestellung Einspeisemanagement'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_ORDER_CONFIRMATION]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_ORDER_CONFIRMATION,
    displayName: 'Netzanmeldung - Bestätigung Bestellung Einspeisemanagement'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_FEED_IN_READY]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_FEED_IN_READY,
    displayName: 'Netzanmeldung - Benachrichtigung Einspeisemanagement bereit'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_PENDING_ASSIGN_TECHNICIAN]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_PENDING_ASSIGN_TECHNICIAN,
    displayName: 'Netzanmeldung - Erinnerung Zuweisung zu Installateur'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_ASSIGNED_TO_TECHNICIAN]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_ASSIGNED_TO_TECHNICIAN,
    displayName: 'Netzanmeldung - Zuweisung zu Installateur erfolgt'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_SHARE_TO_TECHNICIAN_REQUEST]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_SHARE_TO_TECHNICIAN_REQUEST,
    displayName: 'Netzanmeldung - Anfrage Zuweisung zu Installateur'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_SHARE_TO_TECHNICIAN_ACCEPT]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_SHARE_TO_TECHNICIAN_ACCEPT,
    displayName: 'Netzanmeldung - Annahme durch Installateur'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_CORRECT]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_CORRECT,
    displayName: 'Netzanmeldung - Zur Korrektur zurückgezogen'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_REMINDER]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_REMINDER,
    displayName: 'Netzanmeldung - Erinnerung zur Verlängerung'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_SEND_TO_REVIEW]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_SEND_TO_REVIEW,
    displayName: 'Netzanmeldung - In Prüfung geschickt'
  },
  [MailTemplateTypeEnum.TM_GRID_REGISTRATION_SEND_TO_REVIEW_INTERNAL]: {
    value: MailTemplateTypeEnum.TM_GRID_REGISTRATION_SEND_TO_REVIEW_INTERNAL,
    displayName: 'Netzanmeldung - In Prüfung intern'
  },
  [MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_RECEIVED]: {
    value: MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_RECEIVED,
    displayName: 'Netzanmeldung - Eingangsbestätigung Steckersolar'
  },
  [MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_DECLINED]: {
    value: MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_DECLINED,
    displayName: 'Netzanmeldung - Ablehnung Steckersolar'
  },
  [MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_APPROVED_METER]: {
    value: MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_APPROVED_METER,
    displayName: 'Netzanmeldung - Freigabe mit Zählerwechsel Steckersolar'
  },
  [MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_APPROVED_NO_METER]: {
    value: MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_APPROVED_NO_METER,
    displayName: 'Netzanmeldung - Freigabe ohne Zählerwechsel Steckersolar'
  },
  [MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_FEEDBACK_NEEDED]: {
    value: MailTemplateTypeEnum.PLUGIN_GRID_REGISTRATION_FEEDBACK_NEEDED,
    displayName: 'Netzanmeldung - Rückfrage Steckersolar'
  },
  [MailTemplateTypeEnum.GR_NOTIFY_MALO_MELO]: {
    value: MailTemplateTypeEnum.GR_NOTIFY_MALO_MELO,
    displayName: 'Netzanmeldung - Mitteilung Marktlokation und Messlokation'
  },
  [MailTemplateTypeEnum.GR_NOTIFY_TR_SR]: {
    value: MailTemplateTypeEnum.GR_NOTIFY_TR_SR,
    displayName: 'Netzanmeldung - Mitteilung TR und SR'
  },
  [MailTemplateTypeEnum.GR_NEW_FEEDER_DIREKT_MARKET]: {
    value: MailTemplateTypeEnum.GR_NEW_FEEDER_DIREKT_MARKET,
    displayName: 'Netzanmeldung - Nachricht neue Anlage über 100 kW'
  },
  [MailTemplateTypeEnum.GR_IB_CONFIRMED_FEEDER_DIRECT_MARKET]: {
    value: MailTemplateTypeEnum.GR_IB_CONFIRMED_FEEDER_DIRECT_MARKET,
    displayName: 'Netzanmeldung - Nachricht Inbetriebnahme bestätigt über 100 kW'
  },
  [MailTemplateTypeEnum.GR_FEED_IN_MGMT_ORDERED]: {
    value: MailTemplateTypeEnum.GR_FEED_IN_MGMT_ORDERED,
    displayName: 'Netzanmeldung - Einspeisemanagement bestellt'
  },
  [MailTemplateTypeEnum.GR_FEED_IN_MGMT_ORDERED_PARAMETRIZE]: {
    value: MailTemplateTypeEnum.GR_FEED_IN_MGMT_ORDERED_PARAMETRIZE,
    displayName: 'Netzanmeldung - Einspeisemanagement parametrieren'
  },

  // Einspeisevertrag
  [MailTemplateTypeEnum.FEEDER_CONTRACT]: {
    value: MailTemplateTypeEnum.FEEDER_CONTRACT,
    displayName: 'Einspeisevertrag - Einspeiservertrag'
  },
  [MailTemplateTypeEnum.PV_REGISTRATION_FORM]: {
    value: MailTemplateTypeEnum.PV_REGISTRATION_FORM,
    displayName: 'Einspeisevertrag - Photovoltaik-Meldeformular'
  },
  [MailTemplateTypeEnum.FEEDER_CONTRACT_CONFIRMED]: {
    value: MailTemplateTypeEnum.FEEDER_CONTRACT_CONFIRMED,
    displayName: 'Einspeisevertrag - Eingangsbestätigung mit Vertrag'
  },
  [MailTemplateTypeEnum.FEEDER_CONTRACT_CONFIRMATION_REQUEST]: {
    value: MailTemplateTypeEnum.FEEDER_CONTRACT_CONFIRMATION_REQUEST,
    displayName: 'Einspeisevertrag - Anfrage zur Bestätigung der Daten'
  },
  [MailTemplateTypeEnum.FEEDER_CONTRACT_ACCEPTED]: {
    value: MailTemplateTypeEnum.FEEDER_CONTRACT_ACCEPTED,
    displayName: 'Einspeisevertrag - Bestätigung mit Vertrag'
  },
  [MailTemplateTypeEnum.FEEDER_CONTRACT_FEEDBACK_NEEDED]: {
    value: MailTemplateTypeEnum.FEEDER_CONTRACT_FEEDBACK_NEEDED,
    displayName: 'Einspeisevertrag - (Nicht genutzt) Rückfrage zu den Daten'
  },
  [MailTemplateTypeEnum.FEEDER_CONTRACT_CONFIRMATION_REQUEST_INFO_SHEET]: {
    value: MailTemplateTypeEnum.FEEDER_CONTRACT_CONFIRMATION_REQUEST_INFO_SHEET,
    displayName: 'Einspeisevertrag - Datenblatt kaufmännisch'
  },
  [MailTemplateTypeEnum.FC_CONFIRMATION_WITHOUT_CONTRACT]: {
    value: MailTemplateTypeEnum.FC_CONFIRMATION_WITHOUT_CONTRACT,
    displayName: 'Einspeisevertrag - Eingangsbestätigung ohne Vertrag'
  },
  [MailTemplateTypeEnum.FC_CONFIRMATION_WITHOUT_CONTRACT_INFO_SHEET]: {
    value: MailTemplateTypeEnum.FC_CONFIRMATION_WITHOUT_CONTRACT_INFO_SHEET,
    displayName: 'Einspeisevertrag - Stammdatenbestätigung Datenblatt'
  },
  [MailTemplateTypeEnum.FEEDER_WITHOUT_CONTRACT_ACCEPTED]: {
    value: MailTemplateTypeEnum.FEEDER_WITHOUT_CONTRACT_ACCEPTED,
    displayName: 'Einspeisevertrag - Bestätigung ohne Vertrag'
  },
  [MailTemplateTypeEnum.FEEDER_CONTRACT_CONFIRMATION_REQUEST_REMINDER]: {
    value: MailTemplateTypeEnum.FEEDER_CONTRACT_CONFIRMATION_REQUEST_REMINDER,
    displayName: 'Einspeisevertrag - Erinnerung'
  },

  // Anschlussänderung
  [MailTemplateTypeEnum.CCR_REQUESTED]: {
    value: MailTemplateTypeEnum.CCR_REQUESTED,
    displayName: 'Anschlussänderung - Angefragt'
  },
  [MailTemplateTypeEnum.CCR_INFO_SHEET]: {
    value: MailTemplateTypeEnum.CCR_INFO_SHEET,
    displayName: 'Anschlussänderung - Datenblatt'
  },
  [MailTemplateTypeEnum.CCR_FEEDBACK_NEEDED]: {
    value: MailTemplateTypeEnum.CCR_FEEDBACK_NEEDED,
    displayName: 'Anschlussänderung - Rückfrage'
  },
  [MailTemplateTypeEnum.CCR_OFFER_CONFIRMATION_REQUEST]: {
    value: MailTemplateTypeEnum.CCR_OFFER_CONFIRMATION_REQUEST,
    displayName: 'Anschlussänderung - Angebotsmail'
  },
  [MailTemplateTypeEnum.CCR_CONFIRMATION_MAIL]: {
    value: MailTemplateTypeEnum.CCR_CONFIRMATION_MAIL,
    displayName: 'Anschlussänderung - Bestellbestätigung'
  }
};
